<template>
	<div id="leading-enterprises">
		<leftnav class="fl"></leftnav>
		<div class="index_left" :style="isCollapse?'margin-left: 0;width:100%':''">
			<govheader ></govheader>
			<div class="index_left_centerpage">
				<div class="heightVh95 whitebox container-flex-center">
							<freeUserTips :type="4" :bgtype="0" isShowPageTitle="高级搜索"></freeUserTips>
						</div> 
			</div>
		</div>
	</div>
</template>
<script>
	import { mapState, mapMutations, mapGetters } from "vuex";
	import $ from "jquery";
	export default {
		name: 'enterpriseTag',
		computed: {
		...mapState({
		isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
		},
		data() {
			return {
				enterprise_id: 0, //机构详情页跳转自带企业id
				msg: "标签筛选页",
				page: 1, //显示的是哪一页
				pagetype: 2,
				enterinarr: [{
						curindex: 1,
						type: 9,
						name: "上市公司",
					},
					{
						curindex: 2,
						type: 1,
						name: "龙头企业",
					},
					{
						curindex: 3,
						type: 2,
						name: "创新企业",
					},
					{
						curindex: 4,
						type: 3,
						name: "优质企业",
					},
					{
						curindex: 5,
						type: 0,
						name: "全部企业",
					},
					{
						curindex: 6,
						type: 6,
						name: "投资机构",
					},
					{
						curindex: 7,
						type: 7,
						name: "科研机构",
					},
					{
						curindex: 8,
						type: 8,
						name: "投资机构所投资的该领域企业",
					},
				],
				haspage: true, //是否还有下一页
				pageSize: 10, //每一页显示的数据条数
				total: 0, //记录总数
				totalPage: 1,
				maxPage: 10, //最大页数  
				enterpristlist: [],
				num: 1,
				testtoken: "-d8d2de4bc22ab997e946f42f9d49b79b",
				notionname: "标签",
				typefont: '龙头企业',
				userdata: {},
			}
		},
		beforeCreate() {
			this.bus.$emit('loading', false);
		},
		created() { },
		mounted() { },

		methods: {
			detailrouterto(path, id, type) {
				let routeUrl = this.$router.resolve({
					path: path,
					query: {
						type: type,
						id: id
					}
				});
				window.open(routeUrl.href, '_blank');
			},
			pageHandler: function(page) {
				this.getEnterpriseList(page);
			},
			getEnterpriseList(pages) {
				this.bus.$emit('loading', true);
				var ajaxurl = "";
				var pagestype = this.pagetype;
				this.page = pages ? pages : 1;
				var tagjson = "&" + this.key + '=' + this.tagid;
				if (pagestype == 1 || pagestype == 2 || pagestype == 3 || pagestype == 9 || pagestype == 0) {
					ajaxurl = this.$api.free.enterprise.list() + '?type=' + pagestype + tagjson + '&page=' + this.page; 
				} else if (this.pagetype == 6) {
					ajaxurl = this.$api.free.investorg.list() + "?province=0" + tagjson + '&page=' + pages;
				} else if (this.pagetype == 7) {
					ajaxurl = this.$api.free.academy.list() + "?province=0" + tagjson + '&page=' + pages;
				}else if(pagestype == 8){ 
						ajaxurl=this.$api.free.investorg.enterpriseList()+'?id='+this.enterprise_id+'&resultType=1&notionCode='+this.tagid; 
				}
				console.log(ajaxurl);
				var that = this;
				console.log(ajaxurl)
				this.$axios.get(ajaxurl, {
					headers: {
						AuthToken: this.userdata.token
					}
				}).then(function(res) {
					// console.log(res.data)  
					console.log(ajaxurl,res.data);
					if (res.data.success) { 
						that.enterpristlist = res.data.list;  
						for (var i = 0; i < res.data.list.length; i++) {
							that.enterpristlist[i].notionlist = that.taglistfun(that.enterpristlist[i].notion,
							that.enterpristlist[i].notionCode, 'notionsort');
							that.enterpristlist[i].taglist = that.taglistfun(that.enterpristlist[i].tag, that.enterpristlist[i].tagCode);
							//创新企业专属
							if (that.pagestype == 2 && that.enterpristlist[i].financingRound == null) {
								that.enterpristlist[i].financingRound = [];
							}
						}
						that.bus.$emit('loading', false);
						that.totalPage = res.data.totalPage;
						that.pageSize = res.data.pageSize; 
						that.total = pagestype == 8 ? res.data.list.length: res.data.totalRecord;
						that.haspage = res.data.list.length == res.data.pageSize;
					} else {

					}
				})
			}
		},
	}
</script>

<style type="text/css" scoped="scoped">
	@import "../../assets/css/zpageNav.css";
</style>